import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tickers: [],
  loading: false,
  error: null,
};

const tickersSlice = createSlice({
  name: "tickers",
  initialState,
  reducers: {
    setTickers: (state, action) => {
      state.tickers = action.payload;
      state.loading = false;
      state.error = null;
    },
    setTickersLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTickersError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearTickersError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setTickers,
  setTickersLoading,
  setTickersError,
  clearTickersError,
} = tickersSlice.actions;

// Selectors - Direct access to tickers state
export const selectTickers = (state) => state.tickers?.tickers || [];
export const selectTickersLoading = (state) => state.tickers?.loading || false;
export const selectTickersError = (state) => state.tickers?.error || null;

export default tickersSlice.reducer;
